/**
 * Shared helpers for identifying "user" nodes across the graph explorer.
 *
 * The set of typenames that count as a person/user is referenced from
 * multiple call sites (node-rendering classification in
 * `useCypherExplorationGraph`, and the per-node selection algorithm in
 * `ExpandNodeAtom`). Centralising here keeps those call sites in lock
 * step — adding a new identity typename only requires editing this list.
 */

const USER_TYPENAMES: ReadonlySet<string> = new Set([
	'AtlassianUser',
	'IdentityUser',
	'AtlassianAccountUser',
	'CustomerUser',
	'AppUser',
]);

/**
 * Returns true when the typename refers to a user/person entity. Both
 * the primary typename and an optional fallback (e.g. the typename
 * coming from the layout sizing input rather than the hydrated
 * display) are checked so transient hydration races don't misclassify
 * a node.
 */
export function isUserTypename(typename: string, fallbackTypename?: string): boolean {
	return (
		USER_TYPENAMES.has(typename) || (!!fallbackTypename && USER_TYPENAMES.has(fallbackTypename))
	);
}
